import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

export interface CentralPartsEmployee {
    _id: string;
    name: string;
    myLocations: Array<string>;
}

export interface LocationEntry {
    _id: string | 'all';
    title: string;
    active?: boolean;
}

export interface LocationsResponse {
    locations: Array<LocationEntry>;
    myLocations?: Array<string> | 'all';
    centralPartsEmployees?: Array<CentralPartsEmployee>;
}

export function filterLocations(
    locations: LocationEntry[],
    options: { activeOnly?: boolean; excludeAll?: boolean } = {},
): LocationEntry[] {
    const { activeOnly = false, excludeAll = false } = options;
    return locations.filter((loc) => {
        if (excludeAll && loc._id === 'all') return false;
        if (activeOnly && loc._id !== 'all' && (loc.active ?? true) !== true) return false;
        return true;
    });
}

const getLocations = async (sessionId: string, showAll?: boolean): Promise<LocationsResponse> => {
    const { data } = await axios.get(`${API_URL}/locations`,
        {
            headers: {
                Authorization: sessionId
            },
            params: {
                showAll
            }
        }
    );
    return data;
};

export const useGetLocations = (showAll?: boolean) => {
    const sessionContext = useContext(SessionContext);
    return useQuery({
        queryKey: ['/locations/find', showAll ?? false, sessionContext?.organizationId ?? ''],
        queryFn: () => getLocations(sessionContext?.sessionId ?? '', showAll),
        enabled: !!sessionContext?.sessionId,
        staleTime: 1000 * 60 * 60,
        gcTime: 1000 * 60 * 60
    });
};
